import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/core/context/axios.tsx
var AxiosPortalContext = createContext({ instance: {} });
var AxiosMenuContext = createContext({ instance: {} });
var AxiosPortalProvider = ({ instance, children }) => {
	return /* @__PURE__ */ jsx(AxiosPortalContext.Provider, {
		value: { instance },
		children
	});
};
var usePortalAxios = () => useContext(AxiosPortalContext);
var AxiosMenuProvider = ({ instance, children }) => {
	return /* @__PURE__ */ jsx(AxiosMenuContext.Provider, {
		value: { instance },
		children
	});
};
var useMenuAxios = () => useContext(AxiosMenuContext);
//#endregion
export { AxiosMenuContext, AxiosMenuProvider, AxiosPortalContext, AxiosPortalProvider, useMenuAxios, usePortalAxios };
